import { render, staticRenderFns } from "./rbConfig.vue?vue&type=template&id=a8424902"
import script from "./rbConfig.vue?vue&type=script&lang=js"
export * from "./rbConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports